import { Box, Typography } from '@mui/material';
import { SideDrawer } from 'framework/ui/mui-builder';
import { InterruptionEmployeeResponseStatus, InterruptionListCardView } from '../types';
import InterruptionList from './InterruptionList';
import InterruptionsDrawerError from './layout/InterruptionsDrawerError';

type InterruptionsDrawerProps = {
  error?: Nullable<string>;
  interruptionsCount: number;
  isOpen: boolean;
  items: InterruptionListCardView[];
  loading: boolean;
  onClose: () => void;
  onUpdateStatus: (id: string, status: InterruptionEmployeeResponseStatus) => Promise<boolean>;
};

const DRAWER_WIDTH = 420;

const DRAWER_CONTENT_SX = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
} as const;

const TITLE_SX = {
  display: 'inline-flex',
  minWidth: 0,
  alignItems: 'center',
  gap: 0.75,
} as const;

const COUNT_SX = {
  display: 'inline-flex',
  width: 18,
  height: 18,
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid',
  borderColor: 'border.default',
  borderRadius: '50%',
} as const;

const InterruptionsDrawerTitle = ({ interruptionsCount }: Pick<InterruptionsDrawerProps, 'interruptionsCount'>) => (
  <Typography component="span" variant="h4" color="textPrimary" sx={TITLE_SX}>
    Interruptions
    <Typography component="span" color="textSecondary" variant="caption" sx={COUNT_SX}>
      {interruptionsCount}
    </Typography>
  </Typography>
);

const InterruptionsDrawer = ({
  error,
  interruptionsCount,
  isOpen,
  items,
  loading,
  onClose,
  onUpdateStatus,
}: InterruptionsDrawerProps) => (
  <SideDrawer
    title={<InterruptionsDrawerTitle interruptionsCount={interruptionsCount} />}
    isOpen={isOpen}
    onClose={onClose}
    width={DRAWER_WIDTH}
    content={
      <Box sx={DRAWER_CONTENT_SX}>
        {error ? <InterruptionsDrawerError /> : null}
        <InterruptionList items={items} loading={loading} onUpdateStatus={onUpdateStatus} />
      </Box>
    }
  />
);

export default InterruptionsDrawer;
